import SearchResults from './searchGrid/SearchResults';
import { searchContext } from '../../context/Context';
import Loader from '../../components/Common/Loader';
import { SearchContext } from '../../types';
import { useReducer } from 'react';
import { initialState, searchComponentReducer } from './reducers/searchComponentReducer';
import EvidenceSummaryModal from './searchGrid/components/modal/EvidenceSummaryModal';
import { RightSidebarLayoutProvider } from './searchGrid/context/RightSidebarLayoutContext';

export default function Search() {
  const { view, source, tab, hasValidParams } = searchContext() as unknown as SearchContext;
  const [state, dispatch] = useReducer(searchComponentReducer, initialState);

  return (
    <>
      {hasValidParams && view && source && tab ? (
        <RightSidebarLayoutProvider>
          <div>
            <SearchResults state={state} dispatch={dispatch} />
            {state.isLoading && <Loader />}
          </div>
        </RightSidebarLayoutProvider>
      ) : (
        <Loader />
      )}

      <EvidenceSummaryModal
        open={state.showEvidenceModal}
        onClose={() => dispatch({ type: 'SET_SHOW_EVIDENCE_MODAL', payload: false })}
        content={state.evidenceModalContent}
        data={state.evidenceModalData}
      />
    </>
  );
}
